import { useQuery } from '@tanstack/react-query';
import { Challenge } from 'types';
import { getQuests } from '../API';

export const questsQueryKey = 'quests';

export function useGetQuests(challengeId: Challenge['id']) {
  return useQuery([questsQueryKey, challengeId], () => getQuests(challengeId));
}
